import useSWR from 'swr'

import { FetchError } from '../fetchError'
import { FetchBackgroundTaskStatusResponse } from '../fetchResponse'
import { FetchBackgroundTaskStatusResult } from '../fetchResult'
import { fetchBackgroundTaskStatus } from '../fetchers'
import {
  BackgroundTaskPhase,
  BackgroundTaskStatus,
  SerializableValidationResult,
} from './models'

export function useBackgroundTaskStatus<
  ErrorType = SerializableValidationResult[],
>(
  locationUrl: string,
  retry?: string,
): FetchBackgroundTaskStatusResult<BackgroundTaskStatus<ErrorType>> {
  const getRefreshInterval = (
    latestData:
      | FetchBackgroundTaskStatusResponse<BackgroundTaskStatus<ErrorType>>
      | undefined,
  ) => {
    // If task phase is completed, stop refreshing
    const isCompleted =
      latestData?.body?.phase === BackgroundTaskPhase.Completed
    if (isCompleted) return 0

    // Otherwise, use the retry interval from the response or default to 5 seconds
    const retryIntervalInSeconds = retry || latestData?.retry || 5
    const retryIntervalInMilliSeconds = 1000 * Number(retryIntervalInSeconds)

    return retryIntervalInMilliSeconds
  }

  const { data, error, isLoading, mutate } = useSWR<
    FetchBackgroundTaskStatusResponse<BackgroundTaskStatus<ErrorType>>,
    FetchError
  >(locationUrl, fetchBackgroundTaskStatus<BackgroundTaskStatus<ErrorType>>, {
    refreshInterval: getRefreshInterval,
  })

  const result: FetchBackgroundTaskStatusResult<
    BackgroundTaskStatus<ErrorType>
  > = {
    data: data?.body,
    retry: data?.retry,
    error,
    isLoading,
    mutate,
  }

  return result
}
